import { Textarea, TextareaProps } from "@/components/Textarea";
import { camelToKebabConverter } from "@/helpers/camelToKebabConverter";
import { getDataAutomationId, getDataLinkAttributes } from "@/helpers";
import { BuilderBlockProps, CallbackReturnType } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { ChangeEvent, FC, PropsWithChildren } from "react";

type TextareaBlockProps = {
  dlt?: string;
  dld?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => CallbackReturnType;
  onInvalid?: (event: unknown) => CallbackReturnType;
  onBlur?: (event: unknown) => CallbackReturnType;
} & TextareaProps &
  Pick<BuilderProps, "builderContext"> &
  BuilderBlockProps;

export const TextareaBlock: FC<PropsWithChildren<TextareaBlockProps>> = ({
  attributes,
  builderContext,
  dlt,
  dld,
  ...props
}) => {
  return (
    <Textarea
      {...attributes}
      {...props}
      value={props.value ?? ""}
      {...getDataLinkAttributes({ dld, dlt })}
      {...getDataAutomationId(camelToKebabConverter(props.name))}
    />
  );
};
